(function(){

    'use strict';
    

    function pxWebhooksList(
        $timeout, $filter, toastr, $http, WebhookService, $ngBootbox,
        $rootScope
    ) {
        return {
            restrict: 'EA',
            scope: {
                context:  '=context',
                tenant:   '=tenant',
                me:       '=me',
                meta:     '=meta',
                callback: '&callback',
            },
            
        templateUrl: 'app/components/applications/webhooksList/webhooksList.template.html',
        link: function(scope) {

            scope.listContainer = {};
            scope.checkAllCheckboxes = false;
            scope.selectedItems = 0;
            scope.LOADING = false;

            (() => {
                getPage();
                setListeners();
            })();

            function getPage() {
                scope.listContainer.list = [];
                scope.selectedItems = 0;
                scope.LOADING = true;
                $timeout(() => {
                    WebhookService.getPage().then((response) => {
                        $timeout(() => {
                            scope.listContainer = response;
                            scope.LOADING = false;
                        }, 500)
                    }).catch((error) => {
                        console.log('error', error);
                    });
                }, 50);
            }

            scope.reloadPage = () => {
                getPage();
            }
            
            
            ////////////////////////////////////////////
            // Context dialog
            ////////////////////////////////////////////
            scope.openContext = function (event, context, menuOption) {
                scope.closeAllMenus()
                $timeout(function  () {
                    scope.selectedContextMenuItem  =  menuOption;
                    scope.contextContent = context;
                    scope.nestedContext = context;
                    scope.auxiliaries = {
                        tenant: scope.tenant,
                        me: scope.me,
                    };
                }, 50)
            }


            scope.closeAllMenus = () => {
                scope.menuContent = null;
                scope.menuSpecs = null;
                scope.selectedContextMenuItem = null;
                scope.contextContent = null;
            }


            ////////////////////////////////////////////
            // List item menu specific actions
            ////////////////////////////////////////////
            scope.openListMenu = (event, item) => {
                scope.closeAllMenus()
                var position = document.getElementById(event.target.id).getBoundingClientRect();
                setTimeout(() => {
                    scope.closeListMenu();
                    scope.listMenuContext = item;
                    scope.listMeta = {
                        position: {left: position.x, top: position.y},
                        parentId: event.target.id,
                        type: 'webhooksList',
                        scrollContainerId: 'WEBHOOKS_SCROLL_CONTAINER'
                    }
                    scope.$apply();
                }, 50)
            }


            scope.closeListMenu = (item, action) => {
                scope.listMenuContext = null;
                scope.listMeta = null;
                let context = {}
                let menuOption = {}
                switch (action) {
                    case 'MODIFY':
                        context    = { name:  'ModifyWebhook', title: 'ModifyWebhook', dontUseTitle: false, dontUseName: true, data: item }
                        menuOption = { title: 'ModifyWebhook', type: 'WEBHOOK_modify', name: 'ModifyWebhook', bypassCloseOutside: true }
                        scope.openContext(null, context, menuOption);
                    break;
                    case 'CREATE_SECRET':
                        context    = { name:  'CreateNewSecret', title: 'CreateNewSecret', dontUseTitle: false, dontUseName: true, data: item }
                        menuOption = { title: 'CreateNewSecret', type: 'WEBHOOK_secret', name: 'CreateNewSecret', bypassCloseOutside: true }
                        scope.openContext(null, context, menuOption);
                    break;
                    case 'TEST_WEBHOOK':
                        context = { name:  'Test', title: 'Test', dontUseTitle: false, dontUseName: true, data: item }
                        menuOption = { title: 'Test', type: 'WEBHOOK_test', name: 'Test', bypassCloseOutside: true }
                        scope.openContext(null, context, menuOption);
                    break;
                    case 'ACTIVATION':
                        context = { name:  'TestWebhook', title: 'TestWebhook', dontUseTitle: false, dontUseName: true }
                        menuOption = { title: 'TestWebhook', type: 'WEBHOOK_activation', name: 'TestWebhook', bypassCloseOutside: true }
                        scope.openContext(null, context, menuOption);
                    break;
                    case 'REMOVE':
                        deleteItems(item);
                    break;
                }
            }


            ////////////////////////////////////////////
            // Delete selected items
            ////////////////////////////////////////////

            function deleteItems(item) {
                const selectedItems = item ? [item] : scope.listContainer.list.findAllElements({options:{isSelected:true}})
                let URLS = selectedItems.map(item => `<li>${item.info.url.replace('https://', '')}</li>`).join('');
                let warning = `${$filter("stringular")($filter("translate")("DeleteWebhooks"))}: <ul>${URLS}</ul>`;
                
                $ngBootbox.confirm(warning).then(() => {

                    WebhookService.delete(selectedItems, () => {
                        let URLS = selectedItems.map(item => `${item.info.url.replace('https://', '')}`).join(' - ');
                        let toast = `${ $filter("stringular")($filter("translate")("WebhooksDeleted"))}: ${URLS}`;
                        getPage();
                        toastr.success(toast);
                    }, () => {
                        getPage();
                    });
                }).catch((error) => {});
            }


            scope.deleteItems = function () {
                deleteItems();
            }


            ////////////////////////////////////////////
            // Monitor selected items
            ////////////////////////////////////////////
            scope.selectAllItems = function() {
                angular.forEach(scope.listContainer.list, function(value) {
                    value.options.isSelected = scope.checkAllCheckboxes;
                });
            };

            scope.$watch(() => {
                if (scope.listContainer.list) {
                    return scope.listContainer.list;
                }
            }, () => {
                if (scope.listContainer.list) {
                    scope.selectedItems = scope.listContainer.list.findAllElements({
                        options: {isSelected: true}
                    }).length;
                    if (!scope.selectedItems) {
                        scope.checkAllCheckboxes = false;
                    } else {
                        scope.checkAllCheckboxes = (scope.selectedItems === scope.listContainer.list.length);
                    }
                }
            }, true);

            ////////////////////////////////////////////
            // Copy to clipboard
            ////////////////////////////////////////////
            scope.copyData = (stringData) => {
                var data = stringData.split(' ')[0];
                var input = document.createElement('input');
                input.setAttribute('value', data);
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input)
                var message = $filter("translate")("CopyToClipboard")
                
                toastr.success(`${message}: ${data}`);
            }

            // var webhookReloadListener = null;
            function setListeners() {
                var webhookReloadListener = $rootScope.$on('WEBHOOK_RELOAD_PAGE', () => {
                    getPage();
                })
                
                scope.$on('$destroy', () => {
                    webhookReloadListener()
                });
            }
            


        }};
    }
    pxWebhooksList.$inject = [
        '$timeout', '$filter', 'toastr', '$http', 'WebhookService', '$ngBootbox',
        '$rootScope'
    ];

    angular
        .module('printix-admin')
        .directive('pxWebhooksList', pxWebhooksList);

})();
